<template>
  <div class="orders-page">
    <header class="orders-header">
      <button
        class="back-btn"
        type="button"
        :aria-label="$t('utils.cancel')"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('shopd.otitle') }}</h1>
    </header>

    <nav class="order-tabs">
      <button
        v-for="(tab, index) in tabs"
        :key="tab.label"
        type="button"
        class="order-tab"
        :class="{ active: activeTab === index }"
        @click="activeTab = index"
      >
        {{ $t(tab.label) }}
      </button>
    </nav>

    <main class="orders-body">
      <div class="empty-state">
        <div class="empty-icon">
          <div class="empty-page-icon">
            <span class="fold" />
            <span class="line line-one" />
            <span class="line line-two" />
          </div>
        </div>
        <p>{{ $t('item.noData') }}</p>
      </div>
    </main>
  </div>
</template>

<script>
import Vue from 'vue';
import { Icon } from 'vant';

Vue.use(Icon);

export default {
  name: 'Myorders',
  data() {
    return {
      activeTab: 0,
      tabs: [
        { label: 'user.waitDeliver' },
        { label: 'user.living' },
        { label: 'user.review' },
        { label: 'user.completed' },
      ],
    };
  },
  created() {
    if (this.$parent && this.$parent.footer) {
      this.$parent.footer('', true);
    }
  },
};
</script>

<style lang="less" scoped>
.orders-page {
  min-height: 100vh;
  padding-bottom: 72px;
  background: #eef7ff;
  color: #07152b;
}

.orders-header {
  position: sticky;
  top: 0;
  z-index: 8;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f6fb;
}

.orders-header h1 {
  margin: 0;
  color: #07152b;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}

.back-btn {
  position: absolute;
  left: 16px;
  top: 50%;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  transform: translateY(-50%);
  background: transparent;
  color: #07152b;
  font-size: 14px;
}

.order-tabs {
  position: sticky;
  top: 58px;
  z-index: 7;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  height: 60px;
  background: #fff;
}

.order-tab {
  position: relative;
  min-width: 0;
  padding: 0 6px;
  border: 0;
  background: transparent;
  color: #5e6572;
  font-size: 14px;
  line-height: 60px;
  text-align: center;
  white-space: nowrap;
}

.order-tab.active {
  color: #07152b;
  font-weight: 700;
}

.order-tab.active::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 54px;
  height: 3px;
  border-radius: 3px;
  transform: translateX(-50%);
  background: #2389ff;
}

.orders-body {
  position: relative;
  min-height: calc(100vh - 190px);
}

.empty-state {
  position: absolute;
  top: 205px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #9aa0aa;
  font-size: 14px;
  line-height: 20px;
}

.empty-state p {
  margin: 10px 0 0;
}

.empty-icon {
  width: 64px;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-page-icon {
  position: relative;
  width: 42px;
  height: 50px;
  border: 2px solid #d2d2d2;
  border-radius: 5px;
  background: #fff;
  box-sizing: border-box;
}

.empty-page-icon::after {
  content: "";
  position: absolute;
  right: -8px;
  top: -8px;
  width: 10px;
  height: 10px;
  border-top: 2px solid #e3e3e3;
  border-right: 2px solid #e3e3e3;
  opacity: 0.8;
}

.fold {
  position: absolute;
  right: -2px;
  top: -2px;
  width: 14px;
  height: 14px;
  border-left: 2px solid #d2d2d2;
  border-bottom: 2px solid #d2d2d2;
  border-radius: 0 4px 0 4px;
  background: #eef7ff;
}

.line {
  position: absolute;
  left: 10px;
  height: 2px;
  border-radius: 2px;
  background: #e0e0e0;
}

.line-one {
  top: 20px;
  width: 18px;
}

.line-two {
  top: 31px;
  width: 25px;
}

.kefu {
  position: fixed;
  right: 15px;
  bottom: 88px;
  z-index: 80;
  width: 62px;
  height: 62px;
}

.kefu_img {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  border: 4px solid #fff;
  border-radius: 50%;
  background: linear-gradient(180deg, #1b7dff 0%, #0d80ff 64%, #fb1426 65%, #fb1426 100%);
  box-shadow: 0 6px 14px rgba(30, 70, 130, 0.25);
  color: #fff;
}

.kefu_img .van-icon {
  font-size: 31px;
}
</style>
